import React, { useState, useEffect } from "react";
import { RiLogoutCircleLine } from "react-icons/ri";
import { BiChevronDown } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { CiSettings } from "react-icons/ci";
import {
  Layout,
  Tag,
  Row,
  Avatar,
  Space,
  Typography,
  Dropdown,
  Image,
} from "antd";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import tenantConfig, { getLogo } from "../../utils/organizationConfig";
const { Header } = Layout;
const { Text } = Typography;

const SiteHeader = () => {
  const { userData, logout } = useAuth();
  const [visible, setVisible] = useState(false);
  const [img, setImg] = useState();
  const [logoUrl, setLogoUrl] = useState(getLogo());
  
  // Re-fetch logo when tenant config is initialized
  useEffect(() => {
    const loadLogo = async () => {
      // Wait for tenant config to initialize if not already loaded
      if (!tenantConfig.isDynamicConfigLoaded()) {
        await tenantConfig.initialize();
      }
      setLogoUrl(getLogo());
    };
    loadLogo();
  }, []);
  
  const showImage = (img) => {
    setImg(img);
    setVisible(true);
  };

  return (
    <Header
      style={{
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0px 22px",
        height: "60px",
        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        borderBottom: "1px solid #e0e0e0",
        zIndex: 1000,
      }}
    >
      <Link to="/">
        <div className="demo-logo">
          <img src={logoUrl} alt="logo" height={50} />
        </div>
      </Link>
      <div className="content">
        <Row justify={"center"} align={"middle"}>
          <Image
            preview={{
              visible,
              src: img,
              onVisibleChange: (value) => {
                setVisible(value);
              },
            }}
          />
          <Space>
            <div className="access">
              <Tag color="orange">
                {userData?.employee?.accessType
                  ? userData?.employee?.accessType
                  : "Customer"}
              </Tag>
              <Avatar
                src={
                  userData?.photoURL
                    ? userData.photoURL
                    : "https://api.dicebear.com/9.x/lorelei/svg"
                }
                size={35}
                style={{ 
                  cursor: "pointer",
                  border: "3px solid ##ffd591",
                }}
                onClick={() => {
                  showImage(userData?.photoURL);
                }}
              />
            </div>
            <Dropdown
              trigger="click"
              menu={
                userData?.employee?.accessType === "Super Admin"
                  ? {
                      items: [
                        {
                          label: <Link to="/settings/general">Settings</Link>,
                          key: "profile",
                          icon: <CiSettings style={{ fontSize: "18px" }} />,
                        },
                        {
                          label: (
                            <Link style={{ color: "red" }} to={"/"}>
                              Log Out
                            </Link>
                          ),
                          key: "logout",
                          icon: (
                            <RiLogoutCircleLine
                              style={{ fontSize: "18px", color: "red" }}
                            />
                          ),
                          onClick: () => {
                            logout();
                          },
                        },
                      ],
                    }
                  : {
                      items: [
                        {
                          label: (
                            <Link style={{ color: "red" }} to={"/"}>
                              Log Out
                            </Link>
                          ),
                          key: "logout",
                          icon: (
                            <RiLogoutCircleLine
                              style={{ fontSize: "18px", color: "red" }}
                            />
                          ),
                          onClick: () => {
                            logout();
                          },
                        },
                      ],
                    }
              }
            >
              <div
                className="user-info"
                style={{
                  display: "flex",
                  cursor: "pointer",
                }}
              >
                <Text style={{ color: "#101010", padding: 0 }}>
                  {userData?.name}
                </Text>
                <BiChevronDown style={{ fontSize: "20px" }} />
              </div>
            </Dropdown>
          </Space>
        </Row>
      </div>
    </Header>
  );
};

export default SiteHeader;
